const defaultCurrencySymbol = '$';

export function addCurrencySymbol(formattedPrice, currencySymbol) {
  const symbol = currencySymbol || defaultCurrencySymbol;
  const price = formattedPrice || 0;
  return `${symbol}${price}`;
}
